import Vue from "vue"
import VueRouter from "vue-router"
import WidgetMain from "@/views/WidgetMain.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/:appCode",
    component: WidgetMain,
    children: [
      {
        path: "",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "@/components/Home.vue")
      },
      {
        path: "prise-de-rendez-vous-entretien",
        name: "appointment-booking",
        component: () => import(/* webpackChunkName: "appointment-booking" */ "@/components/applications/appointment-booking/AppointmentBooking.vue")
      },
      {
        path: "demande-offre-de-reprise",
        name: "tradein-offer-request",
        component: () => import(/* webpackChunkName: "tradein-offer-request" */ "@/components/applications/tradein-offer-request/TradeinOfferRequest.vue")
      },
      {
        path: "conversation",
        name: "conversation",
        component: () => import(/* webpackChunkName: "conversation" */ "@/components/applications/conversation/Conversation.vue")
      }
    ],
  },
  {
    path: "/:appointmentId/enregistrement-en-ligne",
    redirect: route => {
      const origin = window.location.origin.replace("messenger", "checkin")
      const appointmentId = route.params.appointmentId
      window.location.href = `${origin}/enregistrement-en-ligne/${appointmentId}`
    }
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
